var map = {
	"./sdg_1.svg": [
		71876,
		[
			1876
		]
	],
	"./sdg_10.svg": [
		7132,
		[
			7132
		]
	],
	"./sdg_11.svg": [
		35677,
		[
			5677
		]
	],
	"./sdg_12.svg": [
		73054,
		[
			3054
		]
	],
	"./sdg_13.svg": [
		9455,
		[
			9455
		]
	],
	"./sdg_14.svg": [
		99312,
		[
			9312
		]
	],
	"./sdg_15.svg": [
		90433,
		[
			433
		]
	],
	"./sdg_16.svg": [
		1746,
		[
			1746
		]
	],
	"./sdg_17.svg": [
		88707,
		[
			8707
		]
	],
	"./sdg_2.svg": [
		76471,
		[
			6471
		]
	],
	"./sdg_3.svg": [
		30022,
		[
			22
		]
	],
	"./sdg_4.svg": [
		56905,
		[
			6905
		]
	],
	"./sdg_5.svg": [
		97752,
		[
			7752
		]
	],
	"./sdg_6.svg": [
		58968,
		[
			6587
		]
	],
	"./sdg_7.svg": [
		31322,
		[
			1322
		]
	],
	"./sdg_8.svg": [
		57069,
		[
			7069
		]
	],
	"./sdg_9.svg": [
		5260,
		[
			5260
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25416;
module.exports = webpackAsyncContext;